<div class="dialog-content">
  <form [formGroup]="invoiceDataForm" class="k-form">
    <app-shive-dropdownlist
      #shiveDropdownList
      [label]="'Template'"
      [data]="templates"
      [permittedUserOperations]="[UserOperation.Delete]"
      [selectedValue]="selectedTemplateOption"
      (afterValueChanged)="selectedTemplateOption = $event"
      (removeBtnClicked)="removeInvoiceTemplate($event)"
    >
    </app-shive-dropdownlist>

    <kendo-formfield orientation="horizontal">
      <kendo-label [for]="invoiceTitle" text="Titel"></kendo-label>
      <kendo-textbox
        showErrorIcon="initial"
        [formControlName]="formControlNames.Title"
        #invoiceTitle
      >
      </kendo-textbox>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label [for]="project" text="Projekt"></kendo-label>
      <kendo-dropdownlist
        textField="text"
        valueField="value"
        [showStickyHeader]="false"
        [data]="projects$ | async"
        [formControlName]="formControlNames.Project"
        (open)="projectDropdownOpened()"
        (selectionChange)="projectChanged($event)"
        #project
      >
      </kendo-dropdownlist>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label [for]="expenditureType" text="Verrechnungstyp"></kendo-label>
      <kendo-dropdownlist
        textField="text"
        valueField="value"
        [data]="expenditureTypeOptions"
        [formControlName]="formControlNames.ExpenditureType"
        #expenditureType
      >
      </kendo-dropdownlist>
    </kendo-formfield>

    <!-- Time & Material Extras: only show if "time_and_material" is selected -->
    @if (
      invoiceDataForm.get(formControlNames.ExpenditureType)?.value?.value ===
      InvoiceType.TimeAndMaterial
    ) {
      <div class="k-d-grid" style="grid-template-columns: 1fr 1fr; gap: 1rem">
        <!-- First Radio Group -->
        <p>Welche Stunden sollen verrechnet werden?</p>
        <div class="k-d-flex">
          <div class="k-form-field-radiobutton-wrap k-d-flex">
            <kendo-radiobutton
              [value]="InvoiceTimespan.TmHours"
              [formControlName]="formControlNames.TmHours"
            ></kendo-radiobutton>
            <kendo-label class="k-radio-label" text="All unverrechneten Stunden"></kendo-label>
          </div>
          <div class="k-form-field-radiobutton-wrap k-d-flex k-ml-4.5">
            <kendo-radiobutton
              [value]="InvoiceTimespan.TmSince"
              [formControlName]="formControlNames.TmHours"
            ></kendo-radiobutton>
            <kendo-label class="k-radio-label" text="Unverrechneten Stunden seit"></kendo-label>
          </div>
        </div>
        @if (invoiceDataForm.get(formControlNames.TmHours)?.value === "allUninvoicedSince") {
          <div class="k-d-grid" style="margin-left: 2rem; margin-top: 1rem">
            <kendo-formfield orientation="horizontal">
              <kendo-label [for]="invoicedSinceDate" text="Von Datum"></kendo-label>
              <kendo-datepicker
                [formControlName]="formControlNames.TmHoursSince"
                #invoicedSinceDate
              ></kendo-datepicker>
            </kendo-formfield>
          </div>
        }
        <!-- Second Radio Group -->
        <p>Wie sollen Stunden gruppiert werden?</p>
        <div class="k-d-flex">
          <div class="k-form-field-radiobutton-wrap k-d-flex">
            <kendo-radiobutton
              [value]="GroupingOptions.ByTask"
              [formControlName]="formControlNames.TmGrouping"
            ></kendo-radiobutton>
            <kendo-label class="k-radio-label" text="Nach Aufgaben"></kendo-label>
          </div>
          <div class="k-form-field-radiobutton-wrap k-d-flex k-ml-4.5">
            <kendo-radiobutton
              [value]="GroupingOptions.ByMember"
              [formControlName]="formControlNames.TmGrouping"
            ></kendo-radiobutton>
            <kendo-label class="k-radio-label" text="Nach Personen"></kendo-label>
          </div>
          <div class="k-form-field-radiobutton-wrap k-d-flex k-ml-4.5">
            <kendo-radiobutton
              [value]="GroupingOptions.ByTimeBlock"
              [formControlName]="formControlNames.TmGrouping"
            ></kendo-radiobutton>
            <kendo-label class="k-radio-label" text="Nach Zeiteinträgen"></kendo-label>
          </div>
        </div>
      </div>
    }

    <kendo-formfield orientation="horizontal">
      <kendo-label [for]="invoiceDate" text="Rechnungsdatum"></kendo-label>
      <kendo-datepicker
        [formControlName]="formControlNames.InvoiceDate"
        #invoiceDate
        appAfterValueChanged
      ></kendo-datepicker>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label [for]="dueDate" text="Zahlungsziel"></kendo-label>
      <kendo-datepicker
        [formControlName]="formControlNames.DueDate"
        #dueDate
        appAfterValueChanged
      ></kendo-datepicker>
    </kendo-formfield>
  </form>
</div>

<footer class="k-d-flex k-justify-content-between">
  <button (click)="close()" kendoButton size="large" themeColor="secondary" class="k-mr-4 !k-pr-4">
    <span class="custom-symbol close k-mr-3"></span>
    <span class="label">Schließen</span>
  </button>

  <button kendoButton (click)="generate()" class="!k-pr-4" themeColor="base" size="large">
    <fa-icon class="add k-text-white k-mr-3" [icon]="faCirclePlus"></fa-icon>
    <span class="label">Erstellen</span>
  </button>
</footer>
